import * as React from "react";
import moment from "moment";
import { ChipColorKeyComb } from "../obConstants";
import { dateFormat } from "../../../service/dateTimeService";

export interface ITrsHist {
	date: string;
	status: string;
}

export interface IObTransactionHistoryProps {
	data: Array<ITrsHist>;
}

const ObTransactionHistory: React.FC<IObTransactionHistoryProps> = props => {
	let modifiedData = props.data.reduce((a, b) => {
		const year = dateFormat(b.date).getFullYear();
		if (a[year]) {
			a[year].push(b);
		} else {
			a[year] = [b];
		}
		return a;
	}, {} as { [x: string]: Array<ITrsHist> });

	return (
		<div>
			<div className="tran_histry_detal">
				<h4 className="trans_title">Transaction History</h4>
				{Object.keys(modifiedData).map(year => (
					<div className="trans_detail" key={year}>
						<h3 className="instll_date">
							{year}-{modifiedData[year].length}/12 installments
						</h3>
						<ul className="install_tbl">
							{modifiedData[year].map(trsData => (
								<li className="ins_row" key={trsData.date}>
									{/* as per condition need to  add class red green and gray */}
									<div className={"circle ib " + ChipColorKeyComb[trsData.status.toLowerCase()]}></div>
									<div className="data ib">
										<span className="time">{moment(new Date(dateFormat(trsData.date))).format("D MMM YYYY")}</span>
										{trsData.status !== "Success" && (
											<>
												<span className="status">Rejected</span>
												<div className="reason">Mandate approval Failed</div>
											</>
										)}
									</div>
								</li>
							))}
						</ul>
					</div>
				))}
			</div>
		</div>
	);
};

export default ObTransactionHistory;
